module.exports = ".row{\r\n    padding:20px 0px 10px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/client/client-from/client-from.component.css
// module id = ./src/app/client/client-from/client-from.component.css
// module chunks = main